import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-station-events chart-box box" }
const _hoisted_2 = { class: "chart-wrapper h-100" }
const _hoisted_3 = { class: "chart-actions" }
const _hoisted_4 = { ref: "chart" }
const _hoisted_5 = { class: "h-100 w-100 center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chart?.resetZoom())),
          class: "mdi mdi-home is-clickable is-size-6"
        })
      ]),
      _createElementVNode("canvas", _hoisted_4, null, 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_component_n_spin, { size: "large" })
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.loading]
    ])
  ]))
}